// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const ObituaryNotificationToFamilyStatus = {
    Sent: {
        Name: 'Sent',
        Value: 'Sent',
    },
    TextDelivered: {
        Name: 'Text Delivered',
        Value: 'Text Delivered',
    },
    EmailDelivered: {
        Name: 'Email Delivered',
        Value: 'Email Delivered',
    },
    Opened: {
        Name: 'Opened',
        Value: 'Opened',
    },
    Bounced: {
        Name: 'Bounced',
        Value: 'Bounced',
    },
    Errored: {
        Name: 'Errored',
        Value: 'Errored',
    },
}